import { useEffect, useState } from "react";
import { getMessaging, onMessage } from "firebase/messaging";
import styles from "./FirebaseMessaging.module.css";
import {
  getSelectedDms,
  getSelectedPerson,
  storeSelectedCompany,
  storeSelectedPerson,
} from "../utils/auth";

const FirebaseMessaging = () => {
  const [notification, setNotification] = useState(null);

  console.log(notification);
  useEffect(() => {
    if (typeof window !== "undefined" && "serviceWorker" in navigator) {
      const messaging = getMessaging();

      const unsubscribe = onMessage(messaging, (payload) => {
        const employeeDetails = JSON.parse(
          payload.data?.employee_details || "{}"
        );
        const { message, name, profile_picture, chat_unique } = employeeDetails;

        const currentPath = getLastPathSegment(window.location.href);

        const shouldShowNotification = shouldDisplayNotification(
          currentPath,
          chat_unique
        );

        if (!shouldShowNotification) {
          return;
        }

        setNotification({
          message: message || "You have a new message",
          name: name || "New Message",
          profilePicture: profile_picture,
          employeeDetails,
          timestamp: new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
        });

        setTimeout(() => {
          setNotification(null);
        }, 6000);
      });

      return () => unsubscribe();
    }
  }, []);
  const getLastPathSegment = (url) => {
    try {
      const cleanUrl = url.replace(/\/+$/, "");
      const segments = cleanUrl.split("/");

      let lastSegment = segments.pop();

      if (lastSegment && lastSegment.includes("#")) {
        const hashParts = lastSegment.split("#");
        lastSegment = hashParts[hashParts.length - 1];
      }

      if (!lastSegment && segments.length > 0) {
        lastSegment = segments.pop();
      }

      return lastSegment || "";
    } catch (error) {
      console.error("Error parsing URL:", error);
      return "";
    }
  };

  const shouldDisplayNotification = (currentPath, senderId) => {
    const homepageSelected = getSelectedPerson();
    const dmspageSelected = getSelectedDms();
    if (
      currentPath.includes("homepage") &&
      senderId &&
      homepageSelected &&
      senderId.toString() === homepageSelected.chat_unique.toString()
    ) {
      return false;
    }
    console.log(senderId, dmspageSelected?.chat_unique, currentPath);
    if (
      currentPath.includes("dms") &&
      senderId &&
      dmspageSelected &&
      senderId.toString() === dmspageSelected.chat_unique.toString()
    ) {
      return false;
    }

    return true;
  };

  const handleNotificationClick = () => {
    window.location.href = "/homepage";
    console.log(notification);
    setNotification(null);
    storeSelectedPerson(notification?.employeeDetails);
    storeSelectedCompany(notification?.employeeDetails.company_details[0]);
  };

  const handleClose = (e) => {
    e.stopPropagation();
    setNotification(null);
  };

  return (
    <>
      {notification && (
        <div className={styles.notification} onClick={handleNotificationClick}>
          <div className={styles.content}>
            <div className={styles.header}>
              <div className={styles.userInfo}>
                {notification.profilePicture && (
                  <img
                    src={notification.profilePicture}
                    alt={notification.name}
                    className={styles.userAvatar}
                  />
                )}
                <div className={styles.userDetails}>
                  <span className={styles.userName}>{notification.name}</span>
                  <span className={styles.notificationTime}>
                    {notification.timestamp}
                  </span>
                </div>
              </div>
              <button className={styles.closeButton} onClick={handleClose}>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path
                    d="M13 1L1 13M1 1L13 13"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
            </div>
            <div className={styles.body}>
              <p>{notification.message}</p>
            </div>
            <div className={styles.footer}>
              <span className={styles.indicator}>New message</span>
              <div className={styles.progressContainer}>
                <div className={styles.progressBar}></div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FirebaseMessaging;
